var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:{
    badge: true,
    [`badge-${_vm.status_class}`]: true
}},[_vm._v(_vm._s(_vm.status_text))])
}
var staticRenderFns = []

export { render, staticRenderFns }